import React, { Suspense, useEffect } from 'react';
//import { useParams } from "react-router-dom";
import { useSelector } from 'react-redux'
import { Route } from 'react-router-dom'
import PopupListener from '../components/PopupListener';
import { Auth } from '../services/Auth';
// import Utils from '../services/Utils';
import IframeOptionsEnum from '../components/casino/IframeOptionsEnum';
import useDeviceType from '../hooks/general/useDeviceType';

// Import all possible layouts
import { MainLayout } from "./MainLayout";
import { MultiViewLayout } from "./MultiViewLayout";
import { GamesFullViewLayout } from "./GamesFullViewLayout";

// Import mobile components
const MobileGameView = React.lazy(() => import("../components/casino/MobileGameView"));
const NotFound = React.lazy(() => import('../routes/NotFound'));

export const DemoPages = ['casino', 'casino-lobby', 'tvgames-lobby', 'virtualsport-lobby', 'fastgames-lobby', 'single-game'];
export const MultiViewPages = ['livecasino', 'casino-lobby', 'casino', 'tvgames-lobby', 'virtualsport-lobby', 'fastgames-lobby', 'single-game']

/**
 * Universal Game Switch Layout
 * Handles all game routing scenarios:
 * - Desktop MultiView games
 * - Mobile single-view games  
 * - Mobile fullscreen games
 * - Non-game pages fallback
 */
export const GameSwitchLayout = ({ children, matchProps, ...rest }) => {
  
    const { isMobile } = useDeviceType();
    const iFrameOption = useSelector((state) => state.settings.iFrameOption);
  // const params = useParams();
  
  // Determine if this is a fullscreen mobile request
  const isFullscreenRoute = matchProps?.match?.path?.includes('play-fullscreen');
  const isMobileRoute = matchProps?.match?.path?.includes('play-mobile');


  // For mobile routes use appropriate layout based on route type
  if (isMobileRoute || (isMobile && iFrameOption !== IframeOptionsEnum.QuickActionsBar)) {
    return (
      <MainLayout {...rest} matchProps={matchProps}>
        <Suspense fallback={<></>}>
          <MobileGameView 
            isFullscreen={false}
            hasDemo={rest.hasDemo}
            page={rest.page}
          />
        </Suspense>
      </MainLayout>
    );
  }

  if (isFullscreenRoute || (isMobile && iFrameOption === IframeOptionsEnum.QuickActionsBar)) {
    return (
      <GamesFullViewLayout {...rest} matchProps={matchProps}>
        <Suspense fallback={<></>}>
          <MobileGameView 
            isFullscreen={true}
            hasDemo={rest.hasDemo}
            page={rest.page}
          />
        </Suspense>
      </GamesFullViewLayout>
    );
  }
  
  // For desktop users, use MultiViewLayout or MainLayout based on auth/demo status
  const page = matchProps?.match?.params?.page?.replace('multigame', 'casino');
  const isMultivewPage = MultiViewPages.includes(page);
  const hasDemoMode = DemoPages.includes(page) && matchProps.match.params.demo === 'playfun';
  const useMultiViewLayout = hasDemoMode || (Auth.isAuthenticated() && isMultivewPage);
  
  const LayoutComponent = useMultiViewLayout ? MultiViewLayout : MainLayout;
  
  return (
    <LayoutComponent {...rest} matchProps={matchProps}>
      {children}
    </LayoutComponent>
  );
}

/**
 * Universal Game Switch Route
 * Replaces MultiViewRoute, GamesFullViewRoute, and handles mobile game routes
 */
export const GameSwitchRoute = ({ component: Component, isSettingsLoading, language, placeholder: PlaceHolder, alias, pageBgData, ...rest }) => {

  return (
    <Route {...rest} render={matchProps => {
      //for casino alternativ url params name 
      const page = matchProps?.match?.params?.page?.replace('multigame', 'casino');
      const isMultivewPage = MultiViewPages.includes(page)
      const hasDemoMode = DemoPages.includes(page) && matchProps.match.params.demo === 'playfun'

      return (
        <GameSwitchLayout 
          page={page} 
          key={language} 
          isSettingsLoading={isSettingsLoading} 
          alias={alias} 
          hasDemo={hasDemoMode} 
          pageBgData={pageBgData} 
          matchProps={PopupListener.getParams(matchProps)}
        >
          {(isSettingsLoading || !language) && PlaceHolder ? <PlaceHolder /> :
            <Suspense fallback={PlaceHolder ? <PlaceHolder /> : <></>}>
              {!isSettingsLoading ? (!isMultivewPage ? <Suspense fallback={<div></div>}><NotFound /></Suspense> : <Component hasDemo={hasDemoMode} {
                ...PopupListener.getParams(matchProps)
              } />) : null}
            </Suspense>}
        </GameSwitchLayout>
      )
    }
    } />
  )
};
